<template>
    <div class="dashboard-container">
      <!-- 筛选条件区域 -->
      <el-card class="filter-container">
        <div class="filter-item">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
  
          <el-select
            v-model="department"
            placeholder="科室选择"
            style="width: 150px; margin-left: 10px"
          >
            <el-option
              v-for="item in departmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
  
          <el-select
            v-model="diseaseType"
            placeholder="疾病类型"
            style="width: 150px; margin-left: 10px"
          >
            <el-option
              v-for="item in diseaseOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
  
          <el-select
            v-model="riskLevel"
            placeholder="风险等级"
            style="width: 150px; margin-left: 10px"
          >
            <el-option
              v-for="item in riskLevelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
  
          <el-button
            type="primary"
            icon="el-icon-search"
            style="margin-left: 10px"
            @click="handleSearch"
            >查询</el-button
          >
          <el-button
            type="success"
            icon="el-icon-refresh"
            style="margin-left: 10px"
            @click="handleRefresh"
            >刷新</el-button
          >
        </div>
      </el-card>
  
      <!-- 医生工作概览 -->
      <el-row :gutter="20" class="panel-group">
        <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-patient">
              <i class="el-icon-user-solid card-panel-icon"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">今日待处理患者</div>
              <div class="card-panel-num">15人</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-followup">
              <i class="el-icon-date card-panel-icon"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">待随访患者</div>
              <div class="card-panel-num">28人</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-warning">
              <i class="el-icon-warning card-panel-icon"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">异常指标患者</div>
              <div class="card-panel-num">8人</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :lg="6" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-efficiency">
              <i class="el-icon-data-analysis card-panel-icon"></i>
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">治疗有效率</div>
              <div class="card-panel-num">85.7%</div>
            </div>
          </div>
        </el-col>
      </el-row>
  
      <!-- 图表展示区域 - 第一行 -->
      <el-row :gutter="20">
        <!-- 患者风险等级分布与趋势 -->
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>患者风险等级分布与趋势</span>
              <el-radio-group
                v-model="riskChartType"
                size="mini"
                @change="changeRiskChartType"
              >
                <el-radio-button label="trend">趋势图</el-radio-button>
                <el-radio-button label="heat">热力图</el-radio-button>
              </el-radio-group>
            </div>
            <div class="chart" id="riskChart" style="height: 350px"></div>
          </el-card>
        </el-col>
  
        <!-- 患者随访完成情况 -->
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>患者随访完成情况</span>
              <el-radio-group
                v-model="followUpChartType"
                size="mini"
                @change="changeFollowUpChartType"
              >
                <el-radio-button label="bar">柱状图</el-radio-button>
                <el-radio-button label="radar">雷达图</el-radio-button>
              </el-radio-group>
            </div>
            <div class="chart" id="followUpChart" style="height: 350px"></div>
          </el-card>
        </el-col>
      </el-row>
  
      <!-- 图表展示区域 - 第二行 -->
      <el-row :gutter="20" style="margin-top: 20px">
        <!-- 患者疾病进展分析 -->
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>患者疾病进展分析</span>
              <el-select
                v-model="selectedPatient"
                placeholder="选择患者"
                size="mini"
                style="width: 180px"
                @change="changeDiseasePatient"
              >
                <el-option-group
                  v-for="group in patientOptions"
                  :key="group.label"
                  :label="group.label"
                >
                  <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-option-group>
              </el-select>
            </div>
            <div
              class="chart"
              id="diseaseProgressChart"
              style="height: 350px"
            ></div>
          </el-card>
        </el-col>
  
        <!-- 检查单处理与反馈效率 -->
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>检查单处理与反馈效率</span>
              <el-dropdown @command="handleTimeRangeChange">
                <span class="el-dropdown-link">
                  {{ currentTimeRange }}
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="week">本周</el-dropdown-item>
                  <el-dropdown-item command="month">本月</el-dropdown-item>
                  <el-dropdown-item command="quarter">本季度</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="chart" id="checkupChart" style="height: 350px"></div>
          </el-card>
        </el-col>
      </el-row>
  
      <!-- 图表展示区域 - 第三行 -->
      <el-row :gutter="20" style="margin-top: 20px">
        <!-- 患者分类分布 -->
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>患者分类分布</span>
              <el-radio-group
                v-model="distributionType"
                size="mini"
                @change="changeDistributionType"
              >
                <el-radio-button label="disease">疾病类型</el-radio-button>
                <el-radio-button label="severity">严重程度</el-radio-button>
                <el-radio-button label="age">年龄段</el-radio-button>
              </el-radio-group>
            </div>
            <div
              class="chart"
              id="patientDistributionChart"
              style="height: 350px"
            ></div>
          </el-card>
        </el-col>
  
        <!-- 药物使用情况 -->
        <el-col :span="12">
          <el-card class="box-card">
            <div slot="header" class="chart-header">
              <span>药物使用情况</span>
              <el-tabs
                v-model="medicineTab"
                size="mini"
                @tab-click="changeMedicineTab"
                style="margin-left: 20px; display: inline-block"
              >
                <el-tab-pane label="依从性分析" name="compliance"></el-tab-pane>
                <el-tab-pane label="不良反应监测" name="sideEffect"></el-tab-pane>
              </el-tabs>
            </div>
            <div class="chart" id="medicineChart" style="height: 350px"></div>
          </el-card>
        </el-col>
      </el-row>
  
      <!-- 异常指标患者列表 -->
      <el-card class="abnormal-container" style="margin-top: 20px">
        <div slot="header" class="abnormal-header">
          <span
            ><i class="el-icon-warning" style="color: #e6a23c"></i>
            异常指标患者</span
          >
          <el-tag type="danger">需要关注</el-tag>
        </div>
  
        <el-table :data="abnormalPatients" border style="width: 100%">
          <el-table-column
            prop="name"
            label="患者姓名"
            width="100"
          ></el-table-column>
          <el-table-column prop="age" label="年龄" width="80"></el-table-column>
          <el-table-column
            prop="gender"
            label="性别"
            width="80"
          ></el-table-column>
          <el-table-column
            prop="disease"
            label="疾病"
            width="140"
          ></el-table-column>
          <el-table-column
            prop="abnormalIndex"
            label="异常指标"
            width="180"
          ></el-table-column>
          <el-table-column prop="value" label="当前值" width="100">
            <template slot-scope="scope">
              <span style="color: #f56c6c; font-weight: bold">{{
                scope.row.value
              }}</span>
              <span style="color: #909399; margin-left: 5px"
                >({{ scope.row.normalRange }})</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="trend" label="变化趋势" width="180">
            <template slot-scope="scope">
              <div class="trend-mini-chart" :id="'trend-' + scope.$index"></div>
            </template>
          </el-table-column>
          <el-table-column
            prop="lastCheckDate"
            label="最近检查日期"
            width="120"
          ></el-table-column>
          <el-table-column label="操作" width="200">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="handleViewDetail(scope.row)"
                >查看详情</el-button
              >
              <el-button
                type="success"
                size="mini"
                @click="handleContact(scope.row)"
                >联系患者</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-card>
  
      <!-- 治疗方案效果统计 -->
      <el-card class="treatment-container" style="margin-top: 20px">
        <div slot="header" class="treatment-header">
          <span><i class="el-icon-data-line"></i> 治疗方案效果统计</span>
        </div>
  
        <el-table :data="treatmentData" border style="width: 100%">
          <el-table-column
            prop="treatmentName"
            label="治疗方案"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="diseaseType"
            label="适用疾病"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="patientCount"
            label="患者数量"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column prop="effectiveRate" label="有效率" width="180">
            <template slot-scope="scope">
              <el-progress
                :percentage="scope.row.effectiveRate"
                :color="getColorByValue(scope.row.effectiveRate)"
              ></el-progress>
            </template>
          </el-table-column>
          <el-table-column prop="recoveryRate" label="痊愈率" width="180">
            <template slot-scope="scope">
              <el-progress
                :percentage="scope.row.recoveryRate"
                :color="getColorByValue(scope.row.recoveryRate, 'recovery')"
              ></el-progress>
            </template>
          </el-table-column>
          <el-table-column prop="sideEffectRate" label="副作用发生率" width="180">
            <template slot-scope="scope">
              <el-progress
                :percentage="scope.row.sideEffectRate"
                :color="getColorByValue(scope.row.sideEffectRate, 'sideEffect')"
              ></el-progress>
            </template>
          </el-table-column>
          <el-table-column
            prop="avgTreatmentDays"
            label="平均治疗天数"
            width="120"
            align="center"
          ></el-table-column>
          <el-table-column label="详情" width="100" align="center">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click="viewTreatmentDetail(scope.row)"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-card>
  
      <!-- 新增：患者生命体征监测 -->
      <el-card class="vital-signs-container" style="margin-top: 20px">
        <div slot="header" class="vital-signs-header">
          <span><i class="el-icon-monitor"></i> 患者生命体征监测</span>
          <el-select
            v-model="selectedVitalPatient"
            placeholder="选择患者"
            size="mini"
            style="width: 180px"
            @change="changeVitalPatient"
          >
            <el-option
              v-for="item in vitalPatientOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="chart" id="vitalSignsChart" style="height: 350px"></div>
      </el-card>
  
      <!-- 新增：临床决策支持 -->
      <el-card class="decision-support-container" style="margin-top: 20px">
        <div slot="header" class="decision-support-header">
          <span><i class="el-icon-help"></i> 临床决策支持</span>
        </div>
        <el-tabs v-model="decisionTab" type="border-card">
          <el-tab-pane label="诊疗建议" name="treatment">
            <el-table :data="decisionSupportData" style="width: 100%">
              <el-table-column
                prop="patientName"
                label="患者姓名"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="disease"
                label="疾病"
                width="120"
              ></el-table-column>
              <el-table-column
                prop="currentTreatment"
                label="当前治疗方案"
                width="180"
              ></el-table-column>
              <el-table-column prop="suggestion" label="系统建议" min-width="300">
                <template slot-scope="scope">
                  <div
                    v-for="(item, index) in scope.row.suggestions"
                    :key="index"
                    class="suggestion-item"
                  >
                    <i
                      class="el-icon-info"
                      style="color: #409eff; margin-right: 5px"
                    ></i>
                    {{ item }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="reference" label="参考文献" width="150">
                <template slot-scope="scope">
                  <el-button type="text" @click="viewReference(scope.row)"
                    >查看文献</el-button
                  >
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="adoptSuggestion(scope.row)"
                    >采纳建议</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="风险预测" name="risk">
            <div class="risk-prediction-wrapper">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-card shadow="never" class="risk-form-card">
                    <div slot="header">
                      <span>风险预测工具</span>
                    </div>
                    <el-form
                      :model="riskForm"
                      label-width="100px"
                      label-position="left"
                    >
                      <el-form-item label="选择患者:">
                        <el-select
                          v-model="riskForm.patient"
                          placeholder="请选择患者"
                          style="width: 100%"
                        >
                          <el-option
                            v-for="item in riskPatientOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="预测类型:">
                        <el-select
                          v-model="riskForm.type"
                          placeholder="请选择预测类型"
                          style="width: 100%"
                        >
                          <el-option
                            label="住院风险预测"
                            value="hospitalization"
                          ></el-option>
                          <el-option
                            label="并发症风险预测"
                            value="complication"
                          ></el-option>
                          <el-option
                            label="再入院风险预测"
                            value="readmission"
                          ></el-option>
                          <el-option
                            label="治疗响应预测"
                            value="response"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item>
                        <el-button
                          type="primary"
                          @click="predictRisk"
                          :disabled="!riskForm.patient || !riskForm.type"
                        >
                          开始预测
                        </el-button>
                        <el-button @click="riskForm = { patient: '', type: '' }"
                          >重置</el-button
                        >
                      </el-form-item>
                    </el-form>
                  </el-card>
                </el-col>
                <el-col :span="16">
                  <el-card
                    shadow="never"
                    class="risk-result-card"
                    v-if="riskPredictionResult.show"
                  >
                    <div slot="header" class="clearfix">
                      <span>预测结果</span>
                    </div>
                    <el-alert
                      :title="riskPredictionResult.title"
                      :type="riskPredictionResult.type"
                      :description="riskPredictionResult.description"
                      show-icon
                      :closable="false"
                    >
                    </el-alert>
                    <div
                      id="riskPredictionChart"
                      style="width: 100%; height: 300px; margin-top: 20px"
                    ></div>
                  </el-card>
                  <el-empty
                    description="请选择患者和预测类型，然后点击开始预测"
                    v-else
                  ></el-empty>
                </el-col>
              </el-row>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>
  </template>
  
  <script>
  import * as echarts from "echarts";
  
  export default {
    name: "DoctorDashboard",
    data() {
      return {
        // 筛选条件
        dateRange: ["2024-05-01", "2024-05-31"],
        department: "全部",
        diseaseType: "全部",
        riskLevel: "全部",
        pickerOptions: {
          shortcuts: [
            {
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        departmentOptions: [
          { value: "全部", label: "全部" },
          { value: "心内科", label: "心内科" },
          { value: "消化科", label: "消化科" },
          { value: "呼吸科", label: "呼吸科" },
          { value: "神经内科", label: "神经内科" },
          { value: "肿瘤科", label: "肿瘤科" },
        ],
        diseaseOptions: [
          { value: "全部", label: "全部" },
          { value: "冠心病", label: "冠心病" },
          { value: "高血压", label: "高血压" },
          { value: "糖尿病", label: "糖尿病" },
          { value: "肺癌", label: "肺癌" },
          { value: "COPD", label: "COPD" },
          { value: "胃溃疡", label: "胃溃疡" },
          { value: "脑卒中", label: "脑卒中" },
        ],
        riskLevelOptions: [
          { value: "全部", label: "全部" },
          { value: "低风险", label: "低风险" },
          { value: "中风险", label: "中风险" },
          { value: "高风险", label: "高风险" },
          { value: "极高风险", label: "极高风险" },
        ],
  
        // 图表实例
        riskChart: null,
        followUpChart: null,
        diseaseProgressChart: null,
        checkupChart: null,
        patientDistributionChart: null,
        medicineChart: null,
        vitalSignsChart: null,
        riskPredictionChart: null,
        trendCharts: [],
  
        // 控制参数
        riskChartType: "trend",
        followUpChartType: "bar",
        distributionType: "disease",
        medicineTab: "compliance",
        currentTimeRange: "本月",
        selectedPatient: "patient1",
        selectedVitalPatient: "patient1",
        decisionTab: "treatment",
  
        // 患者选择选项
        patientOptions: [
          {
            label: "高风险患者",
            options: [
              { value: "patient1", label: "许昊然（冠心病）" },
              { value: "patient2", label: "苏雅婷（肺癌）" },
              { value: "patient3", label: "林书辰（糖尿病）" },
            ],
          },
          {
            label: "中风险患者",
            options: [
              { value: "patient4", label: "程若曦（高血压）" },
              { value: "patient5", label: "郭子轩（胃溃疡）" },
            ],
          },
        ],
  
        // 生命体征患者选择
        vitalPatientOptions: [
          { value: "patient1", label: "许昊然（冠心病）" },
          { value: "patient2", label: "苏雅婷（肺癌）" },
          { value: "patient3", label: "林书辰（糖尿病）" },
          { value: "patient4", label: "程若曦（高血压）" },
          { value: "patient5", label: "郭子轩（胃溃疡）" },
        ],
  
        // 风险预测患者选择
        riskPatientOptions: [
          { value: "patient1", label: "许昊然（冠心病）" },
          { value: "patient2", label: "苏雅婷（肺癌）" },
          { value: "patient3", label: "林书辰（糖尿病）" },
          { value: "patient4", label: "程若曦（高血压）" },
          { value: "patient5", label: "郭子轩（胃溃疡）" },
        ],
  
        // 风险预测表单
        riskForm: {
          patient: "",
          type: "",
        },
  
        // 风险预测结果
        riskPredictionResult: {
          show: false,
          title: "",
          type: "",
          description: "",
        },
  
        // 异常指标患者数据
        abnormalPatients: [
          {
            name: "许昊然",
            age: 65,
            gender: "男",
            disease: "冠心病",
            abnormalIndex: "心肌酶谱-肌钙蛋白I",
            value: "0.85 ng/mL",
            normalRange: "0-0.4 ng/mL",
            trend: [0.3, 0.4, 0.6, 0.7, 0.85],
            lastCheckDate: "2024-05-16",
          },
          {
            name: "苏雅婷",
            age: 72,
            gender: "男",
            disease: "肺癌",
            abnormalIndex: "肺功能-FEV1",
            value: "58%",
            normalRange: "≥80%",
            trend: [75, 70, 65, 60, 58],
            lastCheckDate: "2024-05-15",
          },
          {
            name: "林书辰",
            age: 58,
            gender: "男",
            disease: "糖尿病",
            abnormalIndex: "糖化血红蛋白",
            value: "8.5%",
            normalRange: "4-6%",
            trend: [7.2, 7.5, 7.8, 8.2, 8.5],
            lastCheckDate: "2024-05-17",
          },
          {
            name: "程若曦",
            age: 67,
            gender: "女",
            disease: "高血压",
            abnormalIndex: "收缩压",
            value: "165 mmHg",
            normalRange: "90-140 mmHg",
            trend: [145, 150, 155, 160, 165],
            lastCheckDate: "2024-05-15",
          },
          {
            name: "郭子轩",
            age: 45,
            gender: "女",
            disease: "胃溃疡",
            abnormalIndex: "胃镜-溃疡面积",
            value: "1.8 cm²",
            normalRange: "<1 cm²",
            trend: [0.8, 1.2, 1.5, 1.6, 1.8],
            lastCheckDate: "2024-05-14",
          },
          {
            name: "韩宇航",
            age: 78,
            gender: "男",
            disease: "脑卒中",
            abnormalIndex: "血压波动",
            value: "30 mmHg",
            normalRange: "<20 mmHg",
            trend: [18, 22, 25, 28, 30],
            lastCheckDate: "2024-05-16",
          },
          {
            name: "江语涵",
            age: 63,
            gender: "女",
            disease: "COPD",
            abnormalIndex: "氧饱和度",
            value: "88%",
            normalRange: "≥95%",
            trend: [94, 92, 90, 89, 88],
            lastCheckDate: "2024-05-17",
          },
          {
            name: "沈思妍",
            age: 52,
            gender: "男",
            disease: "冠心病",
            abnormalIndex: "LDL胆固醇",
            value: "4.8 mmol/L",
            normalRange: "<3.4 mmol/L",
            trend: [3.6, 4.0, 4.3, 4.6, 4.8],
            lastCheckDate: "2024-05-13",
          },
        ],
  
        // 治疗方案数据
        treatmentData: [
          {
            treatmentName: "冠心病二联药物治疗",
            diseaseType: "冠心病",
            patientCount: 45,
            effectiveRate: 92,
            recoveryRate: 40,
            sideEffectRate: 8,
            avgTreatmentDays: 180,
          },
          {
            treatmentName: "肺癌靶向治疗",
            diseaseType: "肺癌",
            patientCount: 28,
            effectiveRate: 85,
            recoveryRate: 32,
            sideEffectRate: 15,
            avgTreatmentDays: 240,
          },
          {
            treatmentName: "糖尿病胰岛素治疗",
            diseaseType: "糖尿病",
            patientCount: 56,
            effectiveRate: 88,
            recoveryRate: 0,
            sideEffectRate: 12,
            avgTreatmentDays: 365,
          },
          {
            treatmentName: "高血压联合降压方案",
            diseaseType: "高血压",
            patientCount: 72,
            effectiveRate: 94,
            recoveryRate: 0,
            sideEffectRate: 6,
            avgTreatmentDays: 365,
          },
          {
            treatmentName: "COPD支气管扩张治疗",
            diseaseType: "COPD",
            patientCount: 35,
            effectiveRate: 82,
            recoveryRate: 25,
            sideEffectRate: 9,
            avgTreatmentDays: 220,
          },
          {
            treatmentName: "胃溃疡质子泵抑制剂治疗",
            diseaseType: "胃溃疡",
            patientCount: 30,
            effectiveRate: 95,
            recoveryRate: 78,
            sideEffectRate: 5,
            avgTreatmentDays: 60,
          },
        ],
  
        // 临床决策支持数据
        decisionSupportData: [
          {
            patientName: "许昊然",
            disease: "冠心病",
            currentTreatment: "阿司匹林+氯吡格雷+他汀类",
            suggestions: [
              "建议增加β受体阻滞剂以控制心率，目前患者心率较快",
              "考虑降低他汀剂量，肝功能指标异常",
              "建议增加冠状动脉CT随访",
            ],
            reference: "中国冠心病二级预防指南(2022)",
          },
          {
            patientName: "苏雅婷",
            disease: "肺癌",
            currentTreatment: "EGFR-TKI靶向治疗",
            suggestions: [
              "根据最新基因检测结果，考虑使用第三代TKI可能获得更好疗效",
              "建议增加免疫治疗联合方案评估",
              "增加骨扫描随访，观察骨转移情况",
            ],
            reference: "NCCN肺癌指南(2024)",
          },
          {
            patientName: "林书辰",
            disease: "糖尿病",
            currentTreatment: "二甲双胍+格列美脲",
            suggestions: [
              "考虑增加SGLT-2抑制剂，对心肾保护作用更佳",
              "血糖控制不达标，建议调整口服药物剂量",
              "建议增加季度眼底检查频率",
            ],
            reference: "中国2型糖尿病防治指南(2023)",
          },
        ],
      };
    },
    mounted() {
      this.$nextTick(() => {
        this.initCharts();
        this.renderTrendMiniCharts();
      });
    },
    methods: {
      // 筛选相关
      handleSearch() {
        this.$message.success("筛选条件已应用");
        this.refreshCharts();
      },
  
      handleRefresh() {
        this.$message.success("数据已刷新");
        this.refreshCharts();
      },
  
      // 图表初始化
      initCharts() {
        this.initRiskChart();
        this.initFollowUpChart();
        this.initDiseaseProgressChart();
        this.initCheckupChart();
        this.initPatientDistributionChart();
        this.initMedicineChart();
        this.initVitalSignsChart();
  
        window.addEventListener("resize", this.resizeAllCharts);
      },
  
      // 图表切换视图
      changeRiskChartType() {
        this.initRiskChart();
      },
  
      changeFollowUpChartType() {
        this.initFollowUpChart();
      },
  
      changeDiseasePatient() {
        this.initDiseaseProgressChart();
      },
  
      changeVitalPatient() {
        this.initVitalSignsChart();
      },
  
      handleTimeRangeChange(command) {
        this.currentTimeRange =
          command === "week" ? "本周" : command === "month" ? "本月" : "本季度";
        this.initCheckupChart();
      },
  
      changeDistributionType() {
        this.initPatientDistributionChart();
      },
  
      changeMedicineTab() {
        this.initMedicineChart();
      },
  
      // 患者风险等级分布与趋势
      initRiskChart() {
        if (this.riskChart) {
          this.riskChart.dispose();
        }
  
        this.riskChart = echarts.init(document.getElementById("riskChart"));
  
        let option = {};
  
        if (this.riskChartType === "trend") {
          option = {
            tooltip: {
              trigger: "axis",
            },
            legend: {
              data: ["低风险", "中风险", "高风险", "极高风险"],
              right: 10,
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: {
              type: "category",
              boundaryGap: false,
              data: ["1月", "2月", "3月", "4月", "5月"],
            },
            yAxis: {
              type: "value",
              name: "患者数量",
            },
            series: [
              {
                name: "低风险",
                type: "line",
                stack: "总量",
                areaStyle: { opacity: 0.3 },
                data: [30, 28, 32, 35, 38],
                itemStyle: {
                  color: "#67C23A",
                },
              },
              {
                name: "中风险",
                type: "line",
                stack: "总量",
                areaStyle: { opacity: 0.3 },
                data: [25, 28, 23, 20, 18],
                itemStyle: {
                  color: "#E6A23C",
                },
              },
              {
                name: "高风险",
                type: "line",
                stack: "总量",
                areaStyle: { opacity: 0.3 },
                data: [15, 16, 14, 12, 10],
                itemStyle: {
                  color: "#F56C6C",
                },
              },
              {
                name: "极高风险",
                type: "line",
                stack: "总量",
                areaStyle: { opacity: 0.3 },
                data: [5, 6, 7, 5, 4],
                itemStyle: {
                  color: "#ff0000",
                },
              },
            ],
          };
        } else {
          const hours = [
            "00",
            "01",
            "02",
            "03",
            "04",
            "05",
            "06",
            "07",
            "08",
            "09",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
          ];
          const days = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
  
          const data = [];
          let baseValue = 3;
  
          for (let i = 0; i < days.length; i++) {
            for (let j = 0; j < hours.length; j++) {
              const value = Math.floor(Math.random() * baseValue);
              const point = [j, i, value];
              if (j >= 8 && j <= 18) {
                point[2] = value + Math.floor(Math.random() * 7) + 1;
              }
              data.push(point);
            }
          }
  
          option = {
            tooltip: {
              position: "top",
              formatter: function (params) {
                return `${days[params.value[1]]} ${
                  hours[params.value[0]]
                }时: 风险等级 ${params.value[2]}`;
              },
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: {
              type: "category",
              data: hours,
              splitArea: {
                show: true,
              },
              name: "时间",
            },
            yAxis: {
              type: "category",
              data: days,
              splitArea: {
                show: true,
              },
              name: "日期",
            },
            visualMap: {
              min: 0,
              max: 10,
              calculable: true,
              orient: "horizontal",
              left: "center",
              bottom: "0%",
              inRange: {
                color: ["#67C23A", "#E6A23C", "#F56C6C", "#ff0000"],
              },
            },
            series: [
              {
                name: "风险等级热力图",
                type: "heatmap",
                data: data,
                label: {
                  show: false,
                },
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          };
        }
  
        this.riskChart.setOption(option);
      },
  
      // 患者随访完成情况
      initFollowUpChart() {
        if (this.followUpChart) {
          this.followUpChart.dispose();
        }
  
        this.followUpChart = echarts.init(
          document.getElementById("followUpChart")
        );
  
        let option = {};
  
        if (this.followUpChartType === "bar") {
          option = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            legend: {
              data: ["按时完成", "延期完成", "未完成"],
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: {
              type: "category",
              data: ["心内科", "消化科", "呼吸科", "神经内科", "肿瘤科"],
            },
            yAxis: {
              type: "value",
              name: "患者数量",
            },
            series: [
              {
                name: "按时完成",
                type: "bar",
                stack: "总量",
                emphasis: {
                  focus: "series",
                },
                data: [42, 35, 28, 30, 22],
                itemStyle: {
                  color: "#67C23A",
                },
              },
              {
                name: "延期完成",
                type: "bar",
                stack: "总量",
                emphasis: {
                  focus: "series",
                },
                data: [15, 12, 10, 8, 13],
                itemStyle: {
                  color: "#E6A23C",
                },
              },
              {
                name: "未完成",
                type: "bar",
                stack: "总量",
                emphasis: {
                  focus: "series",
                },
                data: [5, 3, 4, 2, 5],
                itemStyle: {
                  color: "#F56C6C",
                },
              },
            ],
          };
        } else {
          option = {
            tooltip: {
              trigger: "item",
            },
            legend: {
              data: ["心内科", "消化科", "呼吸科", "神经内科", "肿瘤科"],
              right: 0,
              orient: "vertical",
            },
            radar: {
              indicator: [
                { name: "随访计划完成率", max: 100 },
                { name: "按时完成率", max: 100 },
                { name: "患者满意度", max: 100 },
                { name: "随访详细度", max: 100 },
                { name: "后续跟进率", max: 100 },
              ],
            },
            series: [
              {
                type: "radar",
                data: [
                  {
                    value: [95, 90, 88, 92, 94],
                    name: "心内科",
                    areaStyle: {
                      color: "rgba(64, 158, 255, 0.3)",
                    },
                  },
                  {
                    value: [92, 88, 90, 85, 88],
                    name: "消化科",
                    areaStyle: {
                      color: "rgba(103, 194, 58, 0.3)",
                    },
                  },
                  {
                    value: [85, 82, 87, 80, 92],
                    name: "呼吸科",
                    areaStyle: {
                      color: "rgba(230, 162, 60, 0.3)",
                    },
                  },
                  {
                    value: [90, 85, 92, 88, 85],
                    name: "神经内科",
                    areaStyle: {
                      color: "rgba(245, 108, 108, 0.3)",
                    },
                  },
                  {
                    value: [82, 78, 85, 90, 80],
                    name: "肿瘤科",
                    areaStyle: {
                      color: "rgba(144, 147, 153, 0.3)",
                    },
                  },
                ],
              },
            ],
          };
        }
  
        this.followUpChart.setOption(option);
      },
  
      // 患者疾病进展分析
      initDiseaseProgressChart() {
        if (this.diseaseProgressChart) {
          this.diseaseProgressChart.dispose();
        }
  
        this.diseaseProgressChart = echarts.init(
          document.getElementById("diseaseProgressChart")
        );
  
        let dataMap = {
          patient1: {
            name: "许昊然（冠心病）",
            indicators: [
              "心功能分级",
              "心肌酶谱",
              "胸痛评分",
              "运动能力",
              "生活质量",
            ],
            values: [
              [3, 2.5, 4, 2, 3], // 初诊
              [2.5, 2, 3.5, 2.5, 3.5], // 1个月随访
              [2, 1.5, 2.5, 3, 4], // 3个月随访
              [1.5, 1, 2, 3.5, 4.5], // 6个月随访
              [1, 0.8, 1.5, 4, 5], // 12个月随访
            ],
          },
          patient2: {
            name: "苏雅婷（肺癌）",
            indicators: ["肿瘤体积", "肺功能", "疼痛评分", "日常活动", "体重"],
            values: [
              [5, 3, 4, 2, 3], // 初诊
              [4.5, 2.8, 3.5, 2.2, 2.8], // 1个月随访
              [4, 2.5, 3, 2.5, 2.5], // 3个月随访
              [3.5, 2.2, 2.5, 3, 2.2], // 6个月随访
              [3, 2, 2, 3.5, 2], // 12个月随访
            ],
          },
          patient3: {
            name: "林书辰（糖尿病）",
            indicators: [
              "血糖水平",
              "糖化血红蛋白",
              "体重指数",
              "肾功能",
              "视网膜状态",
            ],
            values: [
              [4.5, 4, 3.8, 3, 2.5], // 初诊
              [4, 3.8, 3.5, 2.8, 2.5], // 1个月随访
              [3.5, 3.5, 3.3, 2.8, 2.4], // 3个月随访
              [3, 3.2, 3, 2.7, 2.4], // 6个月随访
              [2.8, 3, 2.8, 2.7, 2.3], // 12个月随访
            ],
          },
          patient4: {
            name: "程若曦（高血压）",
            indicators: [
              "收缩压",
              "舒张压",
              "血压波动",
              "靶器官损伤",
              "生活质量",
            ],
            values: [
              [4.8, 4.2, 3.8, 2, 3], // 初诊
              [4.3, 3.8, 3.5, 2, 3.2], // 1个月随访
              [4, 3.5, 3, 2, 3.5], // 3个月随访
              [3.5, 3.2, 2.7, 1.8, 3.8], // 6个月随访
              [3.2, 3, 2.5, 1.8, 4], // 12个月随访
            ],
          },
          patient5: {
            name: "郭子轩（胃溃疡）",
            indicators: [
              "溃疡面积",
              "胃酸分泌",
              "疼痛评分",
              "消化功能",
              "生活质量",
            ],
            values: [
              [4.5, 4.3, 4.5, 3, 2.5], // 初诊
              [3.8, 3.7, 3.5, 3.5, 3], // 1个月随访
              [3, 3, 2.5, 4, 3.5], // 3个月随访
              [2, 2.5, 1.5, 4.5, 4], // 6个月随访
              [1, 2, 1, 5, 4.5], // 12个月随访
            ],
          },
        };
  
        let patientData = dataMap[this.selectedPatient];
        let indicators = patientData.indicators.map((item) => {
          return { name: item, max: 5 };
        });
  
        const option = {
          tooltip: {
            trigger: "item",
          },
          title: {
            text: patientData.name + " - 病情进展图",
            left: "center",
          },
          legend: {
            data: ["初诊", "1个月随访", "3个月随访", "6个月随访", "12个月随访"],
            orient: "vertical",
            right: 10,
            top: "middle",
          },
          radar: {
            indicator: indicators,
          },
          series: [
            {
              type: "radar",
              data: [
                {
                  value: patientData.values[0],
                  name: "初诊",
                  symbol: "circle",
                  symbolSize: 8,
                  areaStyle: {
                    color: "rgba(245, 108, 108, 0.3)",
                  },
                  lineStyle: {
                    width: 2,
                    color: "#F56C6C",
                  },
                  itemStyle: {
                    color: "#F56C6C",
                  },
                },
                {
                  value: patientData.values[1],
                  name: "1个月随访",
                  symbol: "circle",
                  symbolSize: 8,
                  areaStyle: {
                    color: "rgba(230, 162, 60, 0.3)",
                  },
                  lineStyle: {
                    width: 2,
                    color: "#E6A23C",
                  },
                  itemStyle: {
                    color: "#E6A23C",
                  },
                },
                {
                  value: patientData.values[2],
                  name: "3个月随访",
                  symbol: "circle",
                  symbolSize: 8,
                  areaStyle: {
                    color: "rgba(103, 194, 58, 0.3)",
                  },
                  lineStyle: {
                    width: 2,
                    color: "#67C23A",
                  },
                  itemStyle: {
                    color: "#67C23A",
                  },
                },
                {
                  value: patientData.values[3],
                  name: "6个月随访",
                  symbol: "circle",
                  symbolSize: 8,
                  areaStyle: {
                    color: "rgba(64, 158, 255, 0.3)",
                  },
                  lineStyle: {
                    width: 2,
                    color: "#409EFF",
                  },
                  itemStyle: {
                    color: "#409EFF",
                  },
                },
                {
                  value: patientData.values[4],
                  name: "12个月随访",
                  symbol: "circle",
                  symbolSize: 8,
                  areaStyle: {
                    color: "rgba(144, 147, 153, 0.3)",
                  },
                  lineStyle: {
                    width: 2,
                    color: "#909399",
                  },
                  itemStyle: {
                    color: "#909399",
                  },
                },
              ],
            },
          ],
        };
  
        this.diseaseProgressChart.setOption(option);
      },
  
      // 检查单处理与反馈效率
      initCheckupChart() {
        if (this.checkupChart) {
          this.checkupChart.dispose();
        }
  
        this.checkupChart = echarts.init(document.getElementById("checkupChart"));
  
        const dataMap = {
          week: {
            xAxis: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
            issued: [10, 12, 15, 13, 11, 8, 5],
            processingTime: [24, 20, 28, 22, 18, 36, 40],
            feedbackTime: [6, 8, 4, 7, 5, 12, 8],
          },
          month: {
            xAxis: ["第1周", "第2周", "第3周", "第4周", "第5周"],
            issued: [55, 68, 62, 70, 48],
            processingTime: [22, 25, 20, 18, 26],
            feedbackTime: [6, 7, 5, 6, 8],
          },
          quarter: {
            xAxis: ["1月", "2月", "3月"],
            issued: [180, 165, 195],
            processingTime: [24, 20, 18],
            feedbackTime: [7, 6, 5],
          },
        };
  
        const timeRange =
          this.currentTimeRange === "本周"
            ? "week"
            : this.currentTimeRange === "本月"
            ? "month"
            : "quarter";
        const data = dataMap[timeRange];
  
        const option = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              crossStyle: {
                color: "#999",
              },
            },
          },
          legend: {
            data: ["检查单数量", "处理时间(小时)", "反馈时间(小时)"],
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              data: data.xAxis,
              axisPointer: {
                type: "shadow",
              },
            },
          ],
          yAxis: [
            {
              type: "value",
              name: "数量",
              min: 0,
              axisLabel: {
                formatter: "{value}",
              },
            },
            {
              type: "value",
              name: "时间(小时)",
              min: 0,
              axisLabel: {
                formatter: "{value}",
              },
            },
          ],
          series: [
            {
              name: "检查单数量",
              type: "bar",
              data: data.issued,
              itemStyle: {
                color: "#409EFF",
              },
            },
            {
              name: "处理时间(小时)",
              type: "line",
              yAxisIndex: 1,
              data: data.processingTime,
              symbol: "circle",
              symbolSize: 8,
              lineStyle: {
                width: 3,
              },
              itemStyle: {
                color: "#E6A23C",
              },
            },
            {
              name: "反馈时间(小时)",
              type: "line",
              yAxisIndex: 1,
              data: data.feedbackTime,
              symbol: "circle",
              symbolSize: 8,
              lineStyle: {
                width: 3,
              },
              itemStyle: {
                color: "#67C23A",
              },
            },
          ],
        };
  
        this.checkupChart.setOption(option);
      },
  
      // 患者分类分布
      initPatientDistributionChart() {
        if (this.patientDistributionChart) {
          this.patientDistributionChart.dispose();
        }
  
        this.patientDistributionChart = echarts.init(
          document.getElementById("patientDistributionChart")
        );
  
        let option = {};
  
        if (this.distributionType === "disease") {
          option = {
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)",
            },
            legend: {
              type: "scroll",
              orient: "vertical",
              right: 10,
              top: "center",
              data: [
                "冠心病",
                "高血压",
                "糖尿病",
                "肺癌",
                "COPD",
                "胃溃疡",
                "脑卒中",
                "其他",
              ],
            },
            series: [
              {
                name: "疾病类型",
                type: "pie",
                radius: "55%",
                center: ["40%", "50%"],
                data: [
                  { value: 45, name: "冠心病", itemStyle: { color: "#409EFF" } },
                  { value: 72, name: "高血压", itemStyle: { color: "#67C23A" } },
                  { value: 56, name: "糖尿病", itemStyle: { color: "#E6A23C" } },
                  { value: 28, name: "肺癌", itemStyle: { color: "#F56C6C" } },
                  { value: 35, name: "COPD", itemStyle: { color: "#909399" } },
                  { value: 30, name: "胃溃疡", itemStyle: { color: "#9B59B6" } },
                  { value: 24, name: "脑卒中", itemStyle: { color: "#1ABC9C" } },
                  { value: 38, name: "其他", itemStyle: { color: "#3498DB" } },
                ],
                emphasis: {
                  itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: "rgba(0, 0, 0, 0.5)",
                  },
                },
              },
            ],
          };
        } else if (this.distributionType === "severity") {
          option = {
            tooltip: {
              trigger: "item",
              formatter: "{a} <br/>{b} : {c} ({d}%)",
            },
            legend: {
              orient: "vertical",
              right: 10,
              top: "center",
              data: ["轻度", "中度", "重度", "危重"],
            },
            series: [
              {
                name: "严重程度",
                type: "pie",
                radius: ["40%", "70%"],
                center: ["40%", "50%"],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderRadius: 10,
                  borderColor: "#fff",
                  borderWidth: 2,
                },
                label: {
                  show: false,
                  position: "center",
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: "20",
                    fontWeight: "bold",
                  },
                },
                labelLine: {
                  show: false,
                },
                data: [
                  { value: 105, name: "轻度", itemStyle: { color: "#67C23A" } },
                  { value: 85, name: "中度", itemStyle: { color: "#E6A23C" } },
                  { value: 65, name: "重度", itemStyle: { color: "#F56C6C" } },
                  { value: 25, name: "危重", itemStyle: { color: "#ff0000" } },
                ],
              },
            ],
          };
        } else {
          option = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            legend: {
              data: ["男性", "女性"],
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: {
              type: "value",
              boundaryGap: [0, 0.01],
            },
            yAxis: {
              type: "category",
              data: [
                "18-30岁",
                "31-40岁",
                "41-50岁",
                "51-60岁",
                "61-70岁",
                "70岁以上",
              ],
            },
            series: [
              {
                name: "男性",
                type: "bar",
                data: [15, 25, 42, 60, 48, 36],
                itemStyle: {
                  color: "#409EFF",
                },
              },
              {
                name: "女性",
                type: "bar",
                data: [10, 20, 35, 45, 42, 28],
                itemStyle: {
                  color: "#F56C6C",
                },
              },
            ],
          };
        }
  
        this.patientDistributionChart.setOption(option);
      },
  
      // 药物使用情况图表初始化
      initMedicineChart() {
        if (this.medicineChart) {
          this.medicineChart.dispose();
        }
  
        this.medicineChart = echarts.init(
          document.getElementById("medicineChart")
        );
  
        let option = {};
  
        if (this.medicineTab === "compliance") {
          option = {
            tooltip: {
              trigger: "axis",
              axisPointer: {
                type: "shadow",
              },
            },
            legend: {
              data: ["高依从性", "中等依从性", "低依从性", "未服药"],
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              containLabel: true,
            },
            xAxis: {
              type: "category",
              data: ["心内科", "消化科", "呼吸科", "神经内科", "肿瘤科"],
            },
            yAxis: {
              type: "value",
              name: "百分比",
              axisLabel: {
                formatter: "{value}%",
              },
            },
            series: [
              {
                name: "高依从性",
                type: "bar",
                stack: "总量",
                emphasis: {
                  focus: "series",
                },
                data: [65, 58, 62, 70, 55],
                itemStyle: {
                  color: "#67C23A",
                },
              },
              {
                name: "中等依从性",
                type: "bar",
                stack: "总量",
                emphasis: {
                  focus: "series",
                },
                data: [20, 24, 18, 15, 22],
                itemStyle: {
                  color: "#E6A23C",
                },
              },
              {
                name: "低依从性",
                type: "bar",
                stack: "总量",
                emphasis: {
                  focus: "series",
                },
                data: [10, 12, 15, 8, 16],
                itemStyle: {
                  color: "#F56C6C",
                },
              },
              {
                name: "未服药",
                type: "bar",
                stack: "总量",
                emphasis: {
                  focus: "series",
                },
                data: [5, 6, 5, 7, 7],
                itemStyle: {
                  color: "#909399",
                },
              },
            ],
          };
        } else {
          option = {
            tooltip: {
              trigger: "item",
            },
            legend: {
              top: "5%",
              left: "center",
            },
            series: [
              {
                name: "不良反应分布",
                type: "pie",
                radius: ["40%", "70%"],
                avoidLabelOverlap: false,
                itemStyle: {
                  borderRadius: 10,
                  borderColor: "#fff",
                  borderWidth: 2,
                },
                label: {
                  show: false,
                  position: "center",
                },
                emphasis: {
                  label: {
                    show: true,
                    fontSize: "18",
                    fontWeight: "bold",
                  },
                },
                labelLine: {
                  show: false,
                },
                data: [
                  {
                    value: 35,
                    name: "胃肠道反应",
                    itemStyle: { color: "#F56C6C" },
                  },
                  {
                    value: 25,
                    name: "皮肤过敏",
                    itemStyle: { color: "#E6A23C" },
                  },
                  {
                    value: 15,
                    name: "肝功能异常",
                    itemStyle: { color: "#409EFF" },
                  },
                  { value: 12, name: "头晕", itemStyle: { color: "#67C23A" } },
                  { value: 8, name: "嗜睡", itemStyle: { color: "#909399" } },
                  { value: 5, name: "其他", itemStyle: { color: "#9B59B6" } },
                ],
              },
            ],
          };
        }
  
        this.medicineChart.setOption(option);
      },
  
      // 患者生命体征监测
      initVitalSignsChart() {
        if (this.vitalSignsChart) {
          this.vitalSignsChart.dispose();
        }
  
        this.vitalSignsChart = echarts.init(
          document.getElementById("vitalSignsChart")
        );
  
        // 根据选中的患者设置不同的数据
        let vitalData = {};
  
        if (this.selectedVitalPatient === "patient1") {
          // 许昊然（冠心病）
          vitalData = {
            dates: [
              "5.10",
              "5.11",
              "5.12",
              "5.13",
              "5.14",
              "5.15",
              "5.16",
              "5.17",
            ],
            heartRate: [78, 82, 76, 85, 88, 86, 84, 80],
            systolic: [145, 142, 148, 152, 155, 158, 156, 150],
            diastolic: [92, 90, 94, 96, 97, 99, 98, 95],
            oxygen: [98, 97, 98, 97, 98, 97, 98, 98],
            weight: [75.8, 76.0, 75.9, 75.8, 75.7, 75.5, 75.6, 75.4],
          };
        } else if (this.selectedVitalPatient === "patient2") {
          // 苏雅婷（肺癌）
          vitalData = {
            dates: [
              "5.10",
              "5.11",
              "5.12",
              "5.13",
              "5.14",
              "5.15",
              "5.16",
              "5.17",
            ],
            heartRate: [85, 84, 86, 88, 90, 92, 94, 95],
            systolic: [130, 132, 134, 135, 136, 138, 135, 132],
            diastolic: [85, 86, 85, 87, 88, 89, 86, 84],
            oxygen: [94, 93, 93, 92, 91, 90, 89, 88],
            weight: [65.5, 65.2, 64.9, 64.8, 64.5, 64.2, 64.0, 63.8],
          };
        } else if (this.selectedVitalPatient === "patient3") {
          // 林书辰（糖尿病）
          vitalData = {
            dates: [
              "5.10",
              "5.11",
              "5.12",
              "5.13",
              "5.14",
              "5.15",
              "5.16",
              "5.17",
            ],
            heartRate: [76, 75, 78, 77, 80, 82, 80, 79],
            systolic: [138, 140, 142, 145, 148, 146, 145, 143],
            diastolic: [85, 86, 88, 90, 92, 91, 90, 88],
            oxygen: [97, 97, 98, 97, 98, 98, 97, 97],
            weight: [82.5, 82.3, 82.0, 81.8, 81.5, 81.3, 81.1, 80.8],
          };
        } else if (this.selectedVitalPatient === "patient4") {
          // 程若曦（高血压）
          vitalData = {
            dates: [
              "5.10",
              "5.11",
              "5.12",
              "5.13",
              "5.14",
              "5.15",
              "5.16",
              "5.17",
            ],
            heartRate: [75, 74, 76, 78, 80, 82, 84, 86],
            systolic: [155, 158, 160, 162, 165, 168, 170, 165],
            diastolic: [95, 96, 96, 98, 100, 102, 103, 100],
            oxygen: [98, 98, 97, 97, 98, 98, 97, 97],
            weight: [70.2, 70.0, 69.8, 69.7, 69.5, 69.4, 69.2, 69.0],
          };
        } else {
          // 郭子轩（胃溃疡）
          vitalData = {
            dates: [
              "5.10",
              "5.11",
              "5.12",
              "5.13",
              "5.14",
              "5.15",
              "5.16",
              "5.17",
            ],
            heartRate: [72, 74, 75, 74, 76, 75, 73, 72],
            systolic: [125, 127, 128, 130, 129, 128, 127, 125],
            diastolic: [78, 80, 82, 84, 83, 82, 80, 78],
            oxygen: [99, 98, 98, 98, 98, 99, 99, 98],
            weight: [58.5, 58.3, 58.2, 58.0, 57.8, 57.6, 57.4, 57.2],
          };
        }
  
        const option = {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          legend: {
            data: ["心率", "收缩压", "舒张压", "血氧饱和度", "体重"],
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: vitalData.dates,
          },
          yAxis: [
            {
              type: "value",
              name: "心率/血压",
              min: 50,
              max: 200,
              position: "left",
              axisLabel: {
                formatter: "{value}",
              },
            },
            {
              type: "value",
              name: "血氧(%)/体重(kg)",
              min: 50,
              max: 100,
              position: "right",
              axisLabel: {
                formatter: "{value}",
              },
            },
          ],
          series: [
            {
              name: "心率",
              type: "line",
              smooth: true,
              data: vitalData.heartRate,
              itemStyle: {
                color: "#F56C6C",
              },
            },
            {
              name: "收缩压",
              type: "line",
              smooth: true,
              data: vitalData.systolic,
              markLine: {
                silent: true,
                lineStyle: {
                  color: "#E6A23C",
                },
                data: [
                  {
                    yAxis: 140,
                    name: "收缩压警戒线",
                  },
                ],
              },
              itemStyle: {
                color: "#409EFF",
              },
            },
            {
              name: "舒张压",
              type: "line",
              smooth: true,
              data: vitalData.diastolic,
              markLine: {
                silent: true,
                lineStyle: {
                  color: "#E6A23C",
                },
                data: [
                  {
                    yAxis: 90,
                    name: "舒张压警戒线",
                  },
                ],
              },
              itemStyle: {
                color: "#67C23A",
              },
            },
            {
              name: "血氧饱和度",
              type: "line",
              yAxisIndex: 1,
              smooth: true,
              data: vitalData.oxygen,
              markLine: {
                silent: true,
                lineStyle: {
                  color: "#F56C6C",
                },
                data: [
                  {
                    yAxis: 95,
                    name: "血氧警戒线",
                  },
                ],
              },
              itemStyle: {
                color: "#9B59B6",
              },
            },
            {
              name: "体重",
              type: "line",
              yAxisIndex: 1,
              smooth: true,
              data: vitalData.weight,
              itemStyle: {
                color: "#909399",
              },
            },
          ],
        };
  
        this.vitalSignsChart.setOption(option);
      },
  
      // 渲染异常指标患者的趋势迷你图
      renderTrendMiniCharts() {
        // 清除之前的图表实例
        this.trendCharts.forEach((chart) => {
          chart.dispose();
        });
        this.trendCharts = [];
  
        // 为每个异常指标患者创建趋势迷你图
        this.abnormalPatients.forEach((patient, index) => {
          this.$nextTick(() => {
            const chartDom = document.getElementById(`trend-${index}`);
            if (chartDom) {
              const chart = echarts.init(chartDom);
              this.trendCharts.push(chart);
  
              // 确定趋势方向，用于设置颜色
              const trend = patient.trend;
              const isIncreasing = trend[trend.length - 1] > trend[0];
              const color = isIncreasing ? "#F56C6C" : "#67C23A";
  
              // 如果是氧饱和度等指标，增长是好的，下降是坏的，需要反转颜色
              let finalColor = color;
              if (
                (patient.abnormalIndex.includes("氧") ||
                  patient.abnormalIndex.includes("活动") ||
                  patient.abnormalIndex.includes("运动") ||
                  patient.abnormalIndex.includes("功能")) &&
                isIncreasing === false
              ) {
                finalColor = "#F56C6C";
              } else if (
                (patient.abnormalIndex.includes("氧") ||
                  patient.abnormalIndex.includes("活动") ||
                  patient.abnormalIndex.includes("运动") ||
                  patient.abnormalIndex.includes("功能")) &&
                isIncreasing === true
              ) {
                finalColor = "#67C23A";
              }
  
              const option = {
                grid: {
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0,
                },
                xAxis: {
                  type: "category",
                  show: false,
                  boundaryGap: false,
                },
                yAxis: {
                  type: "value",
                  show: false,
                },
                series: [
                  {
                    data: trend,
                    type: "line",
                    smooth: true,
                    symbol: "none",
                    lineStyle: {
                      width: 2,
                      color: finalColor,
                    },
                    areaStyle: {
                      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: finalColor + "80", // 80为透明度
                        },
                        {
                          offset: 1,
                          color: finalColor + "10",
                        },
                      ]),
                    },
                  },
                ],
              };
  
              chart.setOption(option);
            }
          });
        });
      },
  
      // 图表自适应
      resizeAllCharts() {
        if (this.riskChart) {
          this.riskChart.resize();
        }
        if (this.followUpChart) {
          this.followUpChart.resize();
        }
        if (this.diseaseProgressChart) {
          this.diseaseProgressChart.resize();
        }
        if (this.checkupChart) {
          this.checkupChart.resize();
        }
        if (this.patientDistributionChart) {
          this.patientDistributionChart.resize();
        }
        if (this.medicineChart) {
          this.medicineChart.resize();
        }
        if (this.vitalSignsChart) {
          this.vitalSignsChart.resize();
        }
        if (this.riskPredictionChart) {
          this.riskPredictionChart.resize();
        }
        this.trendCharts.forEach((chart) => {
          if (chart) chart.resize();
        });
      },
  
      // 刷新所有图表
      refreshCharts() {
        this.initRiskChart();
        this.initFollowUpChart();
        this.initDiseaseProgressChart();
        this.initCheckupChart();
        this.initPatientDistributionChart();
        this.initMedicineChart();
        this.initVitalSignsChart();
        this.renderTrendMiniCharts();
      },
  
      // 根据值获取颜色
      getColorByValue(value, type = "default") {
        if (type === "sideEffect") {
          // 副作用率，越低越好
          if (value < 5) return "#67C23A";
          if (value < 10) return "#E6A23C";
          if (value < 20) return "#F56C6C";
          return "#ff0000";
        } else if (type === "recovery") {
          // 痊愈率，越高越好
          if (value >= 70) return "#67C23A";
          if (value >= 40) return "#E6A23C";
          if (value >= 10) return "#F56C6C";
          return "#909399";
        } else {
          // 有效率，默认，越高越好
          if (value >= 90) return "#67C23A";
          if (value >= 80) return "#E6A23C";
          if (value >= 60) return "#F56C6C";
          return "#909399";
        }
      },
  
      // 查看患者详情
      handleViewDetail(patient) {
        this.$router.push({
          path: "/follow_up/patient_detail",
          query: {
            patientId: patient.name + "_id", // 实际应用中应使用真实ID
          },
        });
      },
  
      // 联系患者
      handleContact(patient) {
        this.$notify({
          title: "联系患者",
          message: `正在发起与${
            patient.name
          }的联系...\n电话号码: 138****${Math.floor(Math.random() * 10000)
            .toString()
            .padStart(4, "0")}`,
          type: "success",
        });
      },
  
      // 查看治疗方案详情
      viewTreatmentDetail(treatment) {
        this.$alert(
          `${treatment.treatmentName}治疗方案详情：\n\n适用疾病：${treatment.diseaseType}\n患者数量：${treatment.patientCount}人\n有效率：${treatment.effectiveRate}%\n痊愈率：${treatment.recoveryRate}%\n副作用发生率：${treatment.sideEffectRate}%\n平均治疗天数：${treatment.avgTreatmentDays}天\n\n该治疗方案为患者提供了良好的疾病控制和生活质量改善。`,
          "治疗方案详情",
          {
            confirmButtonText: "确定",
            dangerouslyUseHTMLString: true,
          }
        );
      },
  
      // 查看参考文献
      viewReference(data) {
        this.$alert(
          `参考文献：${data.reference}\n\n该指南建议在${
            data.patientName
          }的情况下，可以考虑${data.suggestions.join(
            "，"
          )}等措施来改善治疗效果。`,
          "参考文献",
          {
            confirmButtonText: "确定",
          }
        );
      },
  
      // 采纳系统建议
      adoptSuggestion(data) {
        this.$confirm(
          `确定要采纳对患者"${data.patientName}"的系统建议吗？`,
          "确认信息",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            this.$message({
              type: "success",
              message: "已采纳建议并更新患者治疗方案",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消采纳",
            });
          });
      },
  
      // 预测风险
      predictRisk() {
        if (!this.riskForm.patient || !this.riskForm.type) {
          this.$message.error("请先选择患者和预测类型");
          return;
        }
  
        // 模拟加载
        this.$message({
          message: "正在进行风险评估...",
          type: "info",
        });
  
        setTimeout(() => {
          // 根据不同患者和类型显示不同结果
          const patientMap = {
            patient1: { name: "许昊然", disease: "冠心病" },
            patient2: { name: "苏雅婷", disease: "肺癌" },
            patient3: { name: "林书辰", disease: "糖尿病" },
            patient4: { name: "程若曦", disease: "高血压" },
            patient5: { name: "郭子轩", disease: "胃溃疡" },
          };
  
          const patient = patientMap[this.riskForm.patient];
  
          let result = {
            show: true,
            title: "",
            type: "",
            description: "",
            data: [],
          };
  
          if (this.riskForm.type === "hospitalization") {
            if (
              this.riskForm.patient === "patient1" ||
              this.riskForm.patient === "patient4"
            ) {
              // 高风险
              result.title = `${patient.name}需要住院治疗的风险: 高`;
              result.type = "error";
              result.description = `根据患者的${patient.disease}病情进展和最近的异常指标，预计30天内有65%的概率需要住院治疗。建议加强随访和及时调整治疗方案。`;
              result.data = [65, 35];
            } else {
              // 中低风险
              result.title = `${patient.name}需要住院治疗的风险: 中等`;
              result.type = "warning";
              result.description = `根据患者的${patient.disease}病情进展和最近的指标，预计30天内有30%的概率需要住院治疗。建议定期随访观察。`;
              result.data = [30, 70];
            }
          } else if (this.riskForm.type === "complication") {
            if (
              this.riskForm.patient === "patient2" ||
              this.riskForm.patient === "patient3"
            ) {
              // 高风险
              result.title = `${patient.name}发生并发症的风险: 高`;
              result.type = "error";
              result.description = `根据患者的${patient.disease}病情和检查结果，预计3个月内有58%的概率会发生相关并发症。建议加强监测和预防措施。`;
              result.data = [58, 42];
            } else {
              // 中低风险
              result.title = `${patient.name}发生并发症的风险: 低`;
              result.type = "success";
              result.description = `根据患者的${patient.disease}病情和检查结果，预计3个月内有18%的概率会发生相关并发症。建议维持当前治疗计划。`;
              result.data = [18, 82];
            }
          } else if (this.riskForm.type === "readmission") {
            if (this.riskForm.patient === "patient2") {
              // 高风险
              result.title = `${patient.name}30天内再入院的风险: 高`;
              result.type = "error";
              result.description = `根据患者的${patient.disease}病情和治疗效果，预计出院后30天内有45%的概率会再次入院。建议出院后加强随访和指导。`;
              result.data = [45, 55];
            } else {
              // 中低风险
              result.title = `${patient.name}30天内再入院的风险: 中等`;
              result.type = "warning";
              result.description = `根据患者的${patient.disease}病情和治疗效果，预计出院后30天内有25%的概率会再次入院。建议定期电话随访。`;
              result.data = [25, 75];
            }
          } else {
            // response
            if (this.riskForm.patient === "patient5") {
              // 良好
              result.title = `${patient.name}对当前治疗方案的响应预测: 良好`;
              result.type = "success";
              result.description = `根据患者的${patient.disease}病情和治疗历史，预计对当前治疗方案有82%的概率会取得良好反应。建议继续当前治疗方案。`;
              result.data = [82, 18];
            } else if (
              this.riskForm.patient === "patient1" ||
              this.riskForm.patient === "patient4"
            ) {
              // 中等
              result.title = `${patient.name}对当前治疗方案的响应预测: 中等`;
              result.type = "warning";
              result.description = `根据患者的${patient.disease}病情和治疗历史，预计对当前治疗方案有60%的概率会取得中等反应。建议考虑适当调整治疗方案。`;
              result.data = [60, 40];
            } else {
              // 较差
              result.title = `${patient.name}对当前治疗方案的响应预测: 较差`;
              result.type = "error";
              result.description = `根据患者的${patient.disease}病情和治疗历史，预计对当前治疗方案有35%的概率会取得良好反应。建议尽快调整治疗方案。`;
              result.data = [35, 65];
            }
          }
  
          this.riskPredictionResult = result;
          this.$nextTick(() => {
            this.initRiskPredictionChart();
          });
        }, 1000);
      },
  
      // 风险预测图表
      initRiskPredictionChart() {
        if (this.riskPredictionChart) {
          this.riskPredictionChart.dispose();
        }
  
        this.riskPredictionChart = echarts.init(
          document.getElementById("riskPredictionChart")
        );
  
        let color =
          this.riskPredictionResult.type === "success"
            ? "#67C23A"
            : this.riskPredictionResult.type === "warning"
            ? "#E6A23C"
            : "#F56C6C";
  
        const option = {
          tooltip: {
            trigger: "item",
          },
          legend: {
            orient: "vertical",
            left: "left",
            data: ["风险概率", "安全概率"],
          },
          series: [
            {
              name: "风险预测",
              type: "pie",
              radius: "70%",
              center: ["50%", "50%"],
              data: [
                {
                  value: this.riskPredictionResult.data[0],
                  name: "风险概率",
                  itemStyle: { color: color },
                },
                {
                  value: this.riskPredictionResult.data[1],
                  name: "安全概率",
                  itemStyle: { color: "#909399" },
                },
              ],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        };
  
        this.riskPredictionChart.setOption(option);
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .dashboard-container {
    padding: 20px;
    background-color: #f0f2f5;
  
    .filter-container {
      margin-bottom: 20px;
  
      .filter-item {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }
    }
  
    .panel-group {
      margin-bottom: 20px;
  
      .card-panel-col {
        margin-bottom: 20px;
      }
  
      .card-panel {
        height: 108px;
        cursor: pointer;
        font-size: 12px;
        position: relative;
        overflow: hidden;
        color: #666;
        background: #fff;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        display: flex;
        justify-content: space-between;
        transition: all 0.3s ease-in-out;
  
        &:hover {
          box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.15);
          transform: translateY(-5px);
        }
  
        .card-panel-icon-wrapper {
          float: left;
          margin: 20px 0 0 20px;
          width: 68px;
          height: 68px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
  
          .card-panel-icon {
            font-size: 36px;
            color: #fff;
          }
        }
  
        .icon-patient {
          background: #40c9c6;
        }
  
        .icon-followup {
          background: #36a3f7;
        }
  
        .icon-warning {
          background: #f4516c;
        }
  
        .icon-efficiency {
          background: #34bfa3;
        }
  
        .card-panel-description {
          float: right;
          margin: 20px 20px 0 0;
          text-align: right;
  
          .card-panel-text {
            font-size: 16px;
            color: #666;
          }
  
          .card-panel-num {
            font-size: 28px;
            margin-top: 5px;
            font-weight: bold;
          }
        }
      }
    }
  
    .box-card {
      .chart-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
  
        span {
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
  
    .abnormal-header,
    .treatment-header,
    .vital-signs-header,
    .decision-support-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
  
      span {
        font-size: 16px;
        font-weight: bold;
      }
    }
  
    .trend-mini-chart {
      width: 100%;
      height: 50px;
    }
  
    .suggestion-item {
      padding: 5px 0;
      border-bottom: 1px dashed #eee;
      &:last-child {
        border-bottom: none;
      }
    }
  
    .risk-prediction {
      .risk-form {
        margin-bottom: 20px;
      }
  
      .risk-result {
        margin-top: 20px;
      }
    }
  
    .risk-prediction-wrapper {
      .risk-form-card {
        height: 100%;
      }
  
      .risk-result-card {
        height: 100%;
      }
    }
  
    .decision-support-container {
      margin-bottom: 20px;
    }
  }
  </style>
  